import 'swiper/swiper-bundle.css'
import './scss/vitrine.scss'

import { Swiper, SwiperSlide } from "swiper/react"
import { ProdutoCard } from "./components/ProdutoCard"
import type { Produto } from "../../types/produto.props"
import { Navigation, Autoplay, Pagination } from 'swiper/modules'
import { TitleCtn } from '../../components/TitleCtn'

interface UmItemDestaqueBlackProps {
    vitrineMacro: string
    produtos: Produto[]
    tituloVitrine: string | null
    usaCarrossel: boolean
    autoPlayVitrine: boolean
    hostImagem: string
    precoPrincipal: number
    condicaoParcelamento: number
    validaTempoVitrine: boolean
    zordHintLoading: string
    device: number
    vitrineButtonAddToCart: string
    exibeValoresSomenteLogado: boolean
    width: number
    height: number
    hoverImagensVitrine: boolean
    hoverImagensVitrineMobile: boolean
    utilizaFavoritosVitrine: boolean
}
export function UmItemDestaqueBlack({
    vitrineMacro,
    produtos,
    tituloVitrine,
    usaCarrossel,
    autoPlayVitrine,
    hostImagem,
    precoPrincipal,
    condicaoParcelamento,
    validaTempoVitrine,
    zordHintLoading,
    device,
    vitrineButtonAddToCart,
    exibeValoresSomenteLogado,
    width,
    height,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine
}: Readonly<UmItemDestaqueBlackProps>) {
    return (
        <>
            <TitleCtn tituloVitrine={tituloVitrine} />

            <div className="container">
                <div className={`macro-vitrine-1-item-destaque-black ${vitrineMacro}`}>
                    {usaCarrossel ? (
                        <>
                        <Swiper
                            className={`swiper-vitrine-12 ${vitrineMacro}`}
                            modules={[Navigation, Autoplay, Pagination]}
                            navigation={{
                                nextEl: `.swiper-button-next-${vitrineMacro}`,
                                prevEl: `.swiper-button-prev-${vitrineMacro}`,
                            }}
                            pagination={{
                                el: `.swiper-pagination-${vitrineMacro}`,
                                clickable: true,
                            }}
                            slidesPerView={1}
                            rewind
                            {...(autoPlayVitrine
                                ? {
                                    autoplay: {
                                        pauseOnMouseEnter: true,
                                    },
                                    }
                                : {}
                            )}
                            wrapperClass="product-wrapper"
                        >
                            {Object.values(produtos).map((produto, index) => (
                                <SwiperSlide className={produto.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}>
                                    <ProdutoCard
                                        hostImagem={hostImagem}
                                        produto={produto}
                                        index={index}
                                        precoPrincipal={precoPrincipal}
                                        condicaoParcelamento={condicaoParcelamento}
                                        validaTempoVitrine={validaTempoVitrine}
                                        zordHintLoading={zordHintLoading}
                                        device={device}
                                        vitrineButtonAddToCart={vitrineButtonAddToCart}
                                        exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                        width={width}
                                        height={height}
                                        hoverImagensVitrine={hoverImagensVitrine}
                                        hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                        utilizaFavoritosVitrine={utilizaFavoritosVitrine}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        <div className="controls-area flex" style={{ position: "relative" }}>
                            <div className={`swiper-button-prev swiper-button-prev-${vitrineMacro}`}></div>
                            <div className={`swiper-button-next swiper-button-next-${vitrineMacro}`}></div>
                            <div className={`swiper-pagination swiper-pagination-${vitrineMacro}`}></div>
                        </div>
                        </>
                    ) : (
                        <div className="product-wrapper flex column no-carousel">
                            {Object.values(produtos).map((produto, index) => (
                                <div className={produto.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}>
                                    <ProdutoCard
                                        hostImagem={hostImagem}
                                        produto={produto}
                                        index={index}
                                        precoPrincipal={precoPrincipal}
                                        condicaoParcelamento={condicaoParcelamento}
                                        validaTempoVitrine={validaTempoVitrine}
                                        zordHintLoading={zordHintLoading}
                                        device={device}
                                        vitrineButtonAddToCart={vitrineButtonAddToCart}
                                        exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                        width={width}
                                        height={height}
                                        hoverImagensVitrine={hoverImagensVitrine}
                                        hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                        utilizaFavoritosVitrine={utilizaFavoritosVitrine}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
